export default function TerritoryGrabIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" fill="none">
      <rect x="2" y="2" width="60" height="60" rx="12" fill="#EEF1F8" />
      <path d="M6 34c0-14 8-26 20-26 9 0 12 7 10 14-2 6-9 7-11 13-2 7-6 11-11 11-5 0-8-5-8-12z" fill="#1F86C9" transform="translate(0 2)" />
      <path d="M6 34c0-14 8-26 20-26 9 0 12 7 10 14-2 6-9 7-11 13-2 7-6 11-11 11-5 0-8-5-8-12z" fill="#36B6FF" />
      <path d="M40 46c2-6 8-8 14-6 5 2 6 8 4 12-3 6-10 8-15 5-3-2-4-7-3-11z" fill="#C43A55" transform="translate(0 2)" />
      <path d="M40 46c2-6 8-8 14-6 5 2 6 8 4 12-3 6-10 8-15 5-3-2-4-7-3-11z" fill="#FF4F6D" />
      <path d="M33 22c8 0 14 4 14 12s-6 10-12 10" stroke="#9FDBFF" strokeWidth="5" strokeLinecap="round" />
      <rect x="28" y="40" width="13" height="13" rx="3.5" fill="#1F6FA8" />
      <rect x="28" y="37" width="13" height="13" rx="3.5" fill="#36B6FF" />
      <circle cx="32.2" cy="42.3" r="2" fill="#fff" />
      <circle cx="36.8" cy="42.3" r="2" fill="#fff" />
      <circle cx="32.6" cy="42.6" r="1" fill="#1E1F33" />
      <circle cx="37.2" cy="42.6" r="1" fill="#1E1F33" />
      <path d="M32.5 46c1.2 1 2.8 1 4 0" stroke="#1E1F33" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  );
}
